module.exports = __webpack_public_path__ + "img/banner-3.90ed243e.jpg";